import React, { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { selectReachedStep } from 'src/state/order/selectors';
import { OrderStep } from 'src/state/order/types';
import { useAppSelector } from 'src/state/thunk-api';
import { OrderStepService } from 'src/utils/order-step-service';

export interface ProtectedOrderStepProps {
  orderStep: OrderStep;
}

export const ProtectedOrderStep: FC<PropsWithChildren<ProtectedOrderStepProps>> = (props) => {
  const { orderStep, children } = props;
  const reachedStep = useAppSelector(selectReachedStep);
  const isProtectedStep = !OrderStepService.isBefore(orderStep, reachedStep);

  if (isProtectedStep) {
    return <Navigate to={OrderStepService.getStepPath(reachedStep)} replace={true} />;
  }

  return children;
};
